import { useId } from 'react';
import { END_CHOICES, type WhenValue } from './when';

/** Start now or later, and one of a few plain end choices. */
export function WhenPicker({
  value,
  onChange,
}: {
  value: WhenValue;
  onChange: (next: WhenValue) => void;
}) {
  const id = useId();

  return (
    <div className="when">
      <fieldset className="audience__group">
        <legend className="field__label">Starts</legend>
        <div className="audience__choices">
          <label className="settings__toggle">
            <input
              type="radio"
              name={`${id}-start`}
              checked={value.start === 'now'}
              onChange={() => onChange({ ...value, start: 'now' })}
            />
            Now
          </label>
          <label className="settings__toggle">
            <input
              type="radio"
              name={`${id}-start`}
              checked={value.start === 'later'}
              onChange={() => onChange({ ...value, start: 'later' })}
            />
            Later
          </label>
        </div>
        {value.start === 'later' && (
          <div className="when__datetime">
            <label className="field">
              <span className="field__label">Day</span>
              <input
                className="field__input"
                type="date"
                value={value.startDate}
                onChange={(e) => onChange({ ...value, startDate: e.target.value })}
              />
            </label>
            <label className="field">
              <span className="field__label">Time</span>
              <input
                className="field__input"
                type="time"
                value={value.startTime}
                onChange={(e) => onChange({ ...value, startTime: e.target.value })}
              />
            </label>
          </div>
        )}
      </fieldset>

      <fieldset className="audience__group">
        <legend className="field__label">Comes down</legend>
        <div className="audience__choices audience__choices--wrap">
          {END_CHOICES.map((choice) => (
            <label key={choice.value} className="settings__toggle">
              <input
                type="radio"
                name={`${id}-end`}
                checked={value.end === choice.value}
                onChange={() => onChange({ ...value, end: choice.value })}
              />
              {choice.label}
            </label>
          ))}
        </div>
        {value.end === 'date' && (
          <div className="when__datetime">
            <label className="field">
              <span className="field__label">Day</span>
              <input
                className="field__input"
                type="date"
                value={value.endDate}
                onChange={(e) => onChange({ ...value, endDate: e.target.value })}
              />
            </label>
            <label className="field">
              <span className="field__label">Time</span>
              <input
                className="field__input"
                type="time"
                value={value.endTime}
                onChange={(e) => onChange({ ...value, endTime: e.target.value })}
              />
            </label>
          </div>
        )}
      </fieldset>
    </div>
  );
}
